import React from "react"
import { Navigate } from "react-router-dom"
import { useMeQuery } from "../graphql"
import loadable from "@loadable/component"

const DashboardPage = loadable(() => import("../pages/dashboard/Dashboard.page"))

/**
 * Wrapper component for the dashboard that redirects users with no permission groups
 * to their profile page instead of showing the dashboard.
 */
export const DashboardRedirect: React.FC = () => {
	const [{ data }] = useMeQuery()

	// If user has no permission groups, redirect to profile
	if (data?.me && (!data.me.permissionsGroups || data.me.permissionsGroups.length === 0)) {
		return <Navigate to="/profile" replace />
	}

	// Otherwise, show the dashboard
	return <DashboardPage />
}
